(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-accordion"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const faqButtons = document.querySelectorAll('[data-faq-button]');

    faqButtons.forEach((button) => {
      button.addEventListener('click', function () {
        const item = this.closest('[data-faq-item]');
        const content = item.querySelector('[data-faq-content]');
        const isExpanded = this.getAttribute('aria-expanded') === 'true';

        // Close all other items (optional - remove if you want multiple items open)
        // faqButtons.forEach(btn => {
        //   if (btn !== this) {
        //     btn.setAttribute('aria-expanded', 'false');
        //     btn.closest('[data-faq-item]').classList.remove('is-active');
        //   }
        // });

        // Toggle current item
        this.setAttribute('aria-expanded', !isExpanded);
        item.classList.toggle('is-active');

        // Smooth height animation
        if (!isExpanded) {
          content.style.maxHeight = content.scrollHeight + 'px';
        } else {
          content.style.maxHeight = '0px';
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faqs-search"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const searchInput = document.getElementById('faq-search-input');
    const clearBtn = document.getElementById('faq-clear-btn');
    const resultsText = document.getElementById('faq-search-results');

    if (!searchInput) return;

    function searchFAQs() {
      const searchTerm = searchInput.value.toLowerCase().trim();
      const faqItems = document.querySelectorAll('.faq-accordion__item');
      let visibleCount = 0;

      faqItems.forEach((item) => {
        const question = item.querySelector('.faq-accordion__question')?.textContent.toLowerCase() || '';
        const answer = item.querySelector('.faq-accordion__answer')?.textContent.toLowerCase() || '';

        if (searchTerm === '' || question.includes(searchTerm) || answer.includes(searchTerm)) {
          item.style.display = '';
          visibleCount++;
        } else {
          item.style.display = 'none';
        }
      });

      // Update results text
      if (searchTerm !== '') {
        clearBtn.style.display = 'flex';
        resultsText.style.display = 'block';
        if (visibleCount === 0) {
          resultsText.textContent = 'No FAQs found. Try a different search term.';
        } else if (visibleCount === 1) {
          resultsText.textContent = '1 FAQ found';
        } else {
          resultsText.textContent = `${visibleCount} FAQs found`;
        }
      } else {
        clearBtn.style.display = 'none';
        resultsText.style.display = 'none';
      }
    }

    searchInput.addEventListener('input', searchFAQs);

    clearBtn.addEventListener('click', function () {
      searchInput.value = '';
      searchFAQs();
      searchInput.focus();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-programs"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["program-options"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    // Initialize carousel dots for both grids
    const initializeCarouselDots = () => {
      const grids = document.querySelectorAll('[data-carousel-grid]');

      grids.forEach((grid) => {
        const gridId = grid.getAttribute('data-carousel-grid');
        const dotsContainer = document.querySelector(`[data-dots-container="${gridId}"]`);

        if (!dotsContainer) return;

        const dots = dotsContainer.querySelectorAll('.carousel-dot');
        const cards = grid.querySelectorAll('.program-option-card');

        // Check if we have cards
        if (!cards || cards.length === 0) return;

        // Update dots on scroll
        const updateDots = () => {
          const scrollLeft = grid.scrollLeft;
          const gridWidth = grid.offsetWidth;

          // Calculate which card is most visible
          let activeIndex = 0;
          let maxVisibility = 0;

          cards.forEach((card, index) => {
            const cardLeft = card.offsetLeft - grid.offsetLeft;
            const cardRight = cardLeft + card.offsetWidth;

            // Calculate how much of the card is visible
            const visibleLeft = Math.max(scrollLeft, cardLeft);
            const visibleRight = Math.min(scrollLeft + gridWidth, cardRight);
            const visibility = Math.max(0, visibleRight - visibleLeft);

            if (visibility > maxVisibility) {
              maxVisibility = visibility;
              activeIndex = index;
            }
          });

          dots.forEach((dot, index) => {
            dot.classList.toggle('active', index === activeIndex);
          });
        };

        // Throttle scroll events
        let ticking = false;
        grid.addEventListener(
          'scroll',
          () => {
            if (!ticking) {
              window.requestAnimationFrame(() => {
                updateDots();
                ticking = false;
              });
              ticking = true;
            }
          },
          { passive: true }
        );

        // Click dot to scroll
        dots.forEach((dot, index) => {
          dot.addEventListener('click', () => {
            const targetCard = cards[index];
            if (targetCard) {
              const cardLeft = targetCard.offsetLeft - grid.offsetLeft;
              grid.scrollTo({
                left: cardLeft,
                behavior: 'smooth',
              });
            }
          });
        });

        // Initial update
        updateDots();
      });
    };

    // Initialize on load
    initializeCarouselDots();

    // Reinitialize on window resize (for responsive changes)
    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        initializeCarouselDots();
      }, 100);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["student-documents"]) return;
  try {
    
  (function () {
    const collapsibleItems = document.querySelectorAll('.documents__item--collapsible');

    collapsibleItems.forEach(function (item) {
      const header = item.querySelector('.documents__item-header');
      if (!header) return;

      header.addEventListener('click', function () {
        const isOpen = item.classList.contains('is-open');
        item.classList.toggle('is-open');
        header.setAttribute('aria-expanded', !isOpen);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
